// removed by extract-text-webpack-plugin
module.exports = {"container":"_3lW8Y31","content":"_1eJmCBp","message":"_23QFXRT","header":"_2PQizAW","details":"_3CnPFRy"};


//////////////////
// WEBPACK FOOTER
// ./template/components/UnsupportedBrowserMessage/index.css
// module id = ./template/components/UnsupportedBrowserMessage/index.css
// module chunks = client.sitechrome